document.addEventListener('theme:cart:add', e => {
  const button = e.detail.button;
  const handle = button.dataset.handle;
  if(!handle) return;
  getSection(handle);
});

async function getSection(handle) {
  const res = await fetch(`${window.Shopify.routes.root}products/${handle}?section_id=atc-modal`);
  const html = await res.text();
  const container = document.querySelector('[data-modal-container]');
  container.innerHTML = html;

  const carousel = container.querySelector('.pairing-modal__carousel');
  const flickity = new Flickity(carousel, {
    cellAlign: 'left',
    contain: true,
    pageDots: false
  });

  const modal = container.querySelector('wiro-modal');
  modal.showModal();

  flickity.resize();
}
